import { PHONE_NUMBER_AGENT_SYNC_TRIGGER_FIELDS, PHONE_NUMBER_FIELDS, } from "@repo/common";
import { collection, deleteDoc, doc, getDoc, setDoc, Timestamp, } from "firebase/firestore";
import { warnUnknownFields } from "./converterWarnings";
import { prepareForFirestore } from "./utils";
function changesAgentSyncFields(data) {
    return PHONE_NUMBER_AGENT_SYNC_TRIGGER_FIELDS.some((field) => Object.hasOwn(data, field));
}
export function normalizePhoneNumberOwnership(data) {
    if (data.channel === "live" || data.channel === undefined)
        return data;
    return {
        ...data,
        agentId: null,
        companyId: null,
    };
}
export const phoneNumberConverter = {
    toFirestore(value) {
        return prepareForFirestore(normalizePhoneNumberOwnership(value));
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        const channel = data.channel || "live";
        warnUnknownFields("packages/ui PhoneNumber.fromFirestore", data, PHONE_NUMBER_FIELDS);
        return {
            id: snapshot.id,
            path: snapshot.ref.path,
            number: data.number,
            provider: data.provider,
            status: data.status || "active",
            channel,
            agentId: channel === "live" ? data.agentId || null : null,
            companyId: channel === "live" ? data.companyId || null : null,
            lastCallAt: data.lastCallAt instanceof Timestamp ? data.lastCallAt.toDate() : null,
            createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate() : null,
            updatedAt: data.updatedAt instanceof Timestamp ? data.updatedAt.toDate() : null,
            monthlyCostInCents: typeof data.monthlyCostInCents === "number"
                ? data.monthlyCostInCents
                : 0,
            agentSync: data.agentSync && typeof data.agentSync === "object"
                ? {
                    ...data.agentSync,
                    syncedAt: data.agentSync.syncedAt instanceof Timestamp
                        ? data.agentSync.syncedAt.toDate()
                        : data.agentSync.syncedAt || null,
                }
                : undefined,
        };
    },
};
export function phoneNumbersCollection(db) {
    return collection(db, "phoneNumbers").withConverter(phoneNumberConverter);
}
export function phoneNumberDocument(db, phoneNumberId) {
    return doc(db, "phoneNumbers", phoneNumberId).withConverter(phoneNumberConverter);
}
export async function fetchPhoneNumber(db, phoneNumberId) {
    const snapshot = await getDoc(phoneNumberDocument(db, phoneNumberId));
    return snapshot.exists() ? snapshot.data() : null;
}
export async function createPhoneNumber(db, data) {
    const docRef = doc(phoneNumbersCollection(db), data.number);
    const normalizedData = normalizePhoneNumberOwnership(data);
    await setDoc(docRef, {
        ...normalizedData,
        id: docRef.id,
        lastCallAt: null,
        createdAt: new Date(),
    });
    return docRef.id;
}
export async function deletePhoneNumber(db, phoneNumberId) {
    await deleteDoc(phoneNumberDocument(db, phoneNumberId));
}
export async function updatePhoneNumber(db, phoneNumberId, data) {
    const docRef = phoneNumberDocument(db, phoneNumberId);
    const normalizedData = normalizePhoneNumberOwnership(data);
    await setDoc(docRef, {
        ...normalizedData,
        ...(changesAgentSyncFields(data)
            ? {
                agentSync: {
                    status: "pending",
                    syncedAt: null,
                    error: null,
                    affectedCompanyIds: [],
                    affectedAgentCount: 0,
                },
            }
            : {}),
    }, { merge: true });
}
